
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 165.001 165.001"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M140.5 82.04c0 32.3-26.2 58.5-58.5 58.5s-58.5-26.2-58.5-58.5 26.2-58.5 58.5-58.5 58.5 26.2 58.5 58.5zm-57.9-36.8c-20.6 0-37.2 16.6-37.2 37.2s16.6 37.2 37.2 37.2 37.2-16.7 37.2-37.2c0-20.6-16.7-37.2-37.2-37.2zm5.4 9.3c1.5 2.4-2.9 19.7-6 19.7-3.2 0-7.6-17.3-6-19.7.8-1.2 3.4-1.8 6-1.8s5.2.6 6 1.8zm18.4 11.4c-.5 2.8-15.9 11.9-18.1 9.7-2.2-2.2 6.9-17.6 9.7-18.1h.3c2.9-.1 8.7 5.7 8.1 8.4zM66 59.54c2.8.5 11.9 15.9 9.7 18.1-2.2 2.2-17.6-6.9-18.1-9.7-.6-2.7 5.2-8.7 8.1-8.5.1 0 .2 0 .3.1zm44.5 15.7c2.4 1.6 2.4 10.3 0 11.9-2.4 1.5-19.7-2.9-19.7-6 0-2.6 12.3-6.2 17.6-6.3.9 0 1.7.1 2.1.4zm-36.3 7.6c0 3.2-17.3 7.6-19.7 6-2.4-1.6-2.4-10.3 0-11.9.4-.2 1.1-.3 2.1-.3 5.3.1 17.6 3.7 17.6 6.2zm13.7-.9c0 2.8-2.2 5-5 5s-5-2.2-5-5 2.2-5 5-5 5.1 2.3 5 5zm18.9 15.8c.6 2.8-5.6 9-8.4 8.4-2.8-.5-11.9-15.9-9.7-18.1.3-.3.7-.4 1.2-.4 4.2 0 16.5 7.5 16.9 10.1zm-29.5-9.3c2.2 2.2-6.9 17.6-9.7 18.1-2.8.6-9-5.6-8.4-8.4.5-2.5 12.8-10 17-10.1.6-.1 1 .1 1.1.4zm11.5 22c-1.6 2.4-10.4 2.4-11.9 0s2.9-19.7 6-19.7c3.2 0 7.6 17.4 5.9 19.7z"}})])
          )
        }
      }
    